import CryptoJS from 'crypto-js';

// 密钥，需要与后端保持一致
const SECRET_KEY = 'HuiZhi2024Secret';

/**
 * AES解密
 * @param {String} encryptedData 加密的数据 (Base64编码的字符串)
 * @returns {Object} 解密后的对象
 */
export function decrypt(encryptedData) {
  try {
    if (!encryptedData) {
      console.error('解密数据为空');
      return null;
    }

    const key = CryptoJS.enc.Utf8.parse(SECRET_KEY);
    // 直接传入Base64字符串，CryptoJS会自动解析
    // 【关键修复】Java 的 PKCS5Padding 对应 CryptoJS 的 Pkcs7（不是 Pkcs5）
    const decrypted = CryptoJS.AES.decrypt(
      encryptedData,
      key,
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      }
    );

    const decryptedStr = decrypted.toString(CryptoJS.enc.Utf8);
    if (!decryptedStr) {
      console.error('解密结果为空');
      return null;
    }

    // 尝试解析为JSON对象
    try {
      return JSON.parse(decryptedStr);
    } catch (parseError) {
      // 如果不是JSON格式，直接返回字符串
      console.warn('解密结果不是有效的JSON，返回字符串');
      return decryptedStr;
    }
  } catch (error) {
    console.error('解密失败:', error);
    return null;
  }
}

/**
 * AES加密
 * @param {Object|String} data 待加密的数据
 * @returns {String} 加密后的字符串
 */
export function encrypt(data) {
  try {
    const dataStr = typeof data === 'string' ? data : JSON.stringify(data);
    const key = CryptoJS.enc.Utf8.parse(SECRET_KEY);
    const encrypted = CryptoJS.AES.encrypt(dataStr, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
  } catch (error) {
    console.error('加密失败:', error);
    return null;
  }
}
